import React from "react";
import ArchiveIcon from "../icons/ArchiveIcon";
import Dropdown, { DropdownOption } from "./Dropdown";
import { StoredPattern } from "../types/pattern.model";

export type ArchiveFilter = "active" | "archived" | "all";

interface ArchiveFilterOption {
  value: ArchiveFilter;
  label: string;
}

const archiveFilterOptions: ArchiveFilterOption[] = [
  { value: "active", label: "Active" },
  { value: "archived", label: "Archived" },
  { value: "all", label: "All" },
];

export const matchesArchiveFilter = (pattern: StoredPattern, filter: ArchiveFilter): boolean => {
  if (filter === "all") return true;
  return filter === "archived" ? pattern.archivedAt !== null : pattern.archivedAt === null;
};

interface ArchiveFilterDropdownProps {
  filter: ArchiveFilter;
  onFilterSelect: (filter: ArchiveFilter) => void;
  className?: string;
}

const ArchiveFilterDropdown: React.FC<ArchiveFilterDropdownProps> = ({ filter, onFilterSelect, className }) => {
  const selectedOption = archiveFilterOptions.find(option => option.value === filter);

  return (
    <Dropdown label="Show:" selectedLabel={selectedOption?.label ?? 'Active'} icon={<ArchiveIcon />} className={className}>
      {({ close }) => archiveFilterOptions.map(({ value, label }) => (
        <DropdownOption key={value} onClick={() => { onFilterSelect(value); close(); }}>
          <div className="text-sm text-gray-900">{label}</div>
        </DropdownOption>
      ))}
    </Dropdown>
  );
};

export default ArchiveFilterDropdown;
